"use client";
import { Mail, Phone, MapPin, Clock, ArrowRight } from 'lucide-react';
import Link from 'next/link';

export default function ContactSection() {
  const contactInfo = {
    address: {
      line1: "5 Robert St, Atherton QLD 4883",
      line2: "200 Byrnes St, Mareeba QLD 4880",
      region: "Tablelands, QLD"
    },
    email: "admin@duffysfurniture.com.au",
    phone: "Atherton: (07) 4091 1854, Mareeba: (07) 4092 3037",
    hours: {
      weekdays: "Monday - Friday: 8:30 AM - 5:00 PM",
      saturday: "Saturday: 8:30 AM - 1:00 PM",
      sunday: "Sunday: 10:00 AM - 2:00 PM (Atherton Only)"
    }
  };

  return (
    <section className="w-full py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Contact Duffy's Furniture</h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Get in touch with us for expert furniture & bedding solutions in the Tablelands.
          </p>
        </div>

        {/* Contact Cards Grid */}
        <div className=" flex justify-center">
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {/* Address Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/15 transition-all duration-300 border border-white/20">
            <div className="flex flex-col items-center text-center md:items-start md:text-left gap-4">
              <div className="flex items-center justify-center md:justify-start gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#0B4866]/15 text-[#0B4866]">
                  <MapPin size={20} />
                </span>
                <h3 className="font-semibold text-lg">Address</h3>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                {contactInfo.address.line1}<br />
                {contactInfo.address.line2}<br />
                <span className="text-gray-400">{contactInfo.address.region}</span>
              </p>
            </div>
          </div>

          {/* Email Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/15 transition-all duration-300 border border-white/20">
            <div className="flex flex-col items-center text-center md:items-start md:text-left gap-4">
              <div className="flex items-center justify-center md:justify-start gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#0B4866]/15 text-[#0B4866]">
                  <Mail size={20} />
                </span>
                <h3 className="font-semibold text-lg">Email</h3>
              </div>
              <div>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-gray-400 hover:text-[#0B4866] transition-colors text-sm break-all"
                >
                  {contactInfo.email}
                </a>
                <p className="text-gray-400 text-xs mt-1">We'll respond within 24 hours</p>
              </div>
            </div>
          </div>

          {/* Phone Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/15 transition-all duration-300 border border-white/20">
            <div className="flex flex-col items-center text-center md:items-start md:text-left gap-4">
              <div className="flex items-center justify-center md:justify-start gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#0B4866]/15 text-[#0B4866]">
                  <Phone size={20} />
                </span>
                <h3 className="font-semibold text-lg">Telephone</h3>
              </div>
              <div>
                <p className="text-gray-400 text-sm">
                  Atherton: (07) 4091 1854,<br /> Mareeba: (07) 4092 3037
                </p>
                <p className="text-gray-400 text-xs mt-1">Mon-Fri 8:30AM-5PM</p>
              </div>
            </div>
          </div>

          {/* Hours Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/15 transition-all duration-300 border border-white/20">
            <div className="flex flex-col items-center text-center md:items-start md:text-left gap-4">
              <div className="flex items-center justify-center md:justify-start gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#0B4866]/15 text-[#0B4866]">
                  <Clock size={20} />
                </span>
                <h3 className="font-semibold text-lg">Hours</h3>
              </div>
              <div className="text-gray-400 text-xs leading-relaxed">
                <p>{contactInfo.hours.weekdays}</p>
                <p>{contactInfo.hours.saturday}</p>
                <p>{contactInfo.hours.sunday}</p>
              </div>
            </div>
          </div>
        </div>
          </div>

        {/* Google Map Preview */}
        {/* NOTE: Replace the embed URL below with your actual Google Maps embed URL */}
        {/* To get your embed URL: Go to Google Maps > Search your location > Share > Embed a map > Copy the iframe src */}
        <div className="mb-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg overflow-hidden border border-white/20">
            <div className="aspect-video w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3809.9709607129785!2d145.4753614!3d-17.2686398!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6982757164a89fc7%3A0x725e8f8cd4334acc!2sDuffy&#39;s%20Furniture%20Court%20%26%20Beds%20R%20Us!5e0!3m2!1sen!2sin!4v1771420870513!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
                title="Duffy's Furniture Location"
              />
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center">
        <Link
  href="/contact"
  className="inline-flex items-center gap-2 bg-[#0B4866] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#0d5f86] transition-all duration-300 shadow-lg hover:shadow-xl"
>
  Visit Contact Page
  <ArrowRight size={20} />
</Link>
        </div>
      </div>
    </section>
  );
}
